export default [
    {
        path: '/nodes',
        component: () => import('../pages/nodes/Index.vue'),
        children: [
            {
                path: '',
                name: 'nodes/list',
                meta: {
                    layout: 'default',
                    breadcrumb: [{ label: 'Nodes' }],
                },
                component: () => import('../pages/nodes/Nodes.vue'),
            },
            {
                path: ':id',
                name: 'nodes/detail',
                meta: {
                    layout: 'default',
                    breadcrumb: [{ label: 'Nodes', to: { name: 'nodes/list' } }, { label: 'Node Detail' }],
                },
                component: () => import('../pages/nodes/NodeDetail.vue'),
            },
        ],
    },
];
